import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import { getPartnerBySlug } from '../api/partners';

const STORAGE_KEY = 'partnerBranding';

export const usePartnerStore = defineStore('partner', () => {
	const restoreFromStorage = () => {
		try {
			const stored = localStorage.getItem(STORAGE_KEY);
			return stored ? JSON.parse(stored) : null;
		} catch {
			return null;
		}
	};

	const persistToStorage = (data) => {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
	};

	const partner = ref(restoreFromStorage());

	const hasPartner = computed(() => partner.value !== null);

	const fetchPartner = async (slug) => {
		if (partner.value?.slug === slug) {
			return partner.value;
		}

		try {
			const data = await getPartnerBySlug(slug);
			setPartner(data);
			return data;
		} catch {
			clearPartner();
			return null;
		}
	};

	const setPartner = (data) => {
		partner.value = data;
		persistToStorage(data);
	};

	const clearPartner = () => {
		partner.value = null;
		localStorage.removeItem(STORAGE_KEY);
	};

	return {
		partner,
		hasPartner,
		fetchPartner,
		setPartner,
		clearPartner,
	};
});
